import { queryCache } from "react-query"
import { ApplicationDispatch } from '../store/application/types';
import { postData } from './fetch';
import { IApplication } from "../Interfaces/Application/IApplication";
import debounce from 'lodash/debounce';
import { Action, ActionResult } from "../utils/BusinessRulesEngine";
import { showValidationDialog } from "../utils/ValidationDialog";

export interface ApplicationBudgetRow {
  id: number;
  name: string;
  type: 'Income' | 'Debt';
  sortOrder?: number;
  isStandard?: boolean;
  primaryValue?: string;
  cobuyer1Value?: string;
  cobuyer2Value?: string;

  primaryJsonPath?: string;
  cobuyer1JsonPath?: string;
  cobuyer2JsonPath?: string;

  deleted?: boolean;
  createdDate?: string;
  updatedDate?: string;

  applicationId?: string;
  budgetRowId?: number;
  budgetRow?: BudgetRow;

  isAutomaticallyCalculated?: boolean;
}

export interface BudgetRow {
  id: number;
  name: string;
  type: 'Income' | 'Debt';
  sortOrder?: number;
  isStandard?: boolean;

  primaryJsonPath?: string;
  cobuyer1JsonPath?: string;
  cobuyer2JsonPath?: string;

  deleted?: boolean;
  createdDate?: string;
  updatedDate?: string;

  isAutomaticallyCalculated?: boolean;
}

export interface ApplicationBudget {
  incomeRows: ApplicationBudgetRow[];
  debtRows: ApplicationBudgetRow[];
  includePrimaryApplicantIncome: boolean;
  includeCoApplicant1Income: boolean;
  includeCoApplicant2Income: boolean;
}

// export const useApplicationBudget = (applicationId: string) => {
//   const dispatch = useDispatch<ApplicationDispatch>();

//   const getApplicationBudget = async (key: string, applicationId: string) => {
//     const url =`api/applicationbudget/${applicationId}`;
//     const response = await fetchData(url, dispatch) as ApplicationBudget;
//     return response;
//   }

//   return useQuery(
//     ['ApplicationBudget', applicationId],
//     getApplicationBudget,
//     {
//       refetchOnWindowFocus: false,
//       isDataEqual: () => false,
//     }
//   )
// }

export const updateApplicationBudget = async (applicationId: string, applicationBudget: ApplicationBudget) => {
  const url = `api/applicationbudget/update/${applicationId}`;
  const response = await postData(url, applicationBudget);
  await resetApplicationBudget();
}

export const resetApplicationBudget = async () => {
  await queryCache.refetchQueries('ApplicationBudget');
}

export const onModifyApplicationBudget = debounce((
  dispatch: ApplicationDispatch,
  applicationBudget: ApplicationBudget,
  app: IApplication,
  businessRulesEngine: (action: Action) => ActionResult,
) => {

  const result = businessRulesEngine({
    action: 'Edit Budget',
    applicationBudget,
  });
  if (result?.errors?.length) {
    showValidationDialog({
      errors: result.errors,
      callback: () => {
        alert('Bypassing "Edit Budget" validation does not do anything yet.');
      },
    });
  }
  // } else if (result.applicationState) {
  //   //dispatch(updateEditingApp(result.application));
  // } else {
  // }


  // const dirty = false;
  // // Update the available income for the quote page.
  // if (app?.applicationQuotes?.[0]?.quote
  //   && app.applicationQuotes[0].quote.availableIncome != applicationBudget.availableIncomeAll) {
  //   app.applicationQuotes[0].quote.availableIncome = applicationBudget.availableIncomeAll;
  //   dirty = true;
  // }

  // Update additional fields.
  // for (const row of applicationBudget.incomeRows) {
  //   dirty = updateAppValue(app, row.primaryJsonPath, row.primaryValue) || dirty;
  //   dirty = updateAppValue(app, row.cobuyer1JsonPath, row.cobuyer1Value) || dirty;
  //   dirty = updateAppValue(app, row.cobuyer2JsonPath, row.cobuyer2Value) || dirty;
  // }
  // for (const row of applicationBudget.debtRows) {
  //   dirty = updateAppValue(app, row.primaryJsonPath, row.primaryValue) || dirty;
  //   dirty = updateAppValue(app, row.cobuyer1JsonPath, row.cobuyer1Value) || dirty;
  //   dirty = updateAppValue(app, row.cobuyer2JsonPath, row.cobuyer2Value) || dirty;
  // }

  // if (dirty) {
  //   dispatch(updateEditingApp(app, businessRulesEngine));
  // }
  // if(dirty) {
  // dispatch(updateBudget(applicationBudget, businessRulesEngine));
  // }
}, 1000);

export const updateIncomeRowsFromApp = (
  incomeRows: ApplicationBudgetRow[],
  app: IApplication
) => {
  for (const row of incomeRows) {
    row.primaryValue = updateBudgetValue(app, row.primaryJsonPath, row.primaryValue);
    row.cobuyer1Value = updateBudgetValue(app, row.cobuyer1JsonPath, row.cobuyer1Value);
    row.cobuyer2Value = updateBudgetValue(app, row.cobuyer2JsonPath, row.cobuyer2Value);
  }
};

export const updateDebtRowsFromApp = (
  debtRows: ApplicationBudgetRow[],
  app: IApplication
) => {
  for (const row of debtRows) {
    row.primaryValue = updateBudgetValue(app, row.primaryJsonPath, row.primaryValue);
    row.cobuyer1Value = updateBudgetValue(app, row.cobuyer1JsonPath, row.cobuyer1Value);
    row.cobuyer2Value = updateBudgetValue(app, row.cobuyer2JsonPath, row.cobuyer2Value);
  }
}

const updateAppValue = (app: IApplication, jsonPath?: string, value?: string) => {
  let obj: Record<string, any> = app;
  if (obj && jsonPath) {
    const paths = jsonPath.split(/[\[\].]/).filter(x => x);
    while (obj && paths?.[1]) {
      obj = obj[paths[0]];
      paths.shift(); // Remove the first path element (go on to the next one).
    }
    // Only try to update if we followed the complete path (it is a valid path).
    if (!paths?.[1] && paths?.[0] != value) {
      obj[paths?.[0]] = value;
      return true;
    }
  }
  return false;
}

const updateBudgetValue = (app: IApplication, jsonPath?: string, previousValue?: string) => {
  let obj: Record<string, any> = app;
  if (obj && jsonPath) {
    const paths = jsonPath.split(/[\[\].]/).filter(x => x);
    while (obj && paths?.[1]) {
      obj = obj[paths[0]];
      paths.shift(); // Remove the first path element (go on to the next one).
    }
    if (!paths?.[1]) { // Only try to update if we followed the complete path (it is a valid path).
      return obj[paths?.[0]];
    } else {
      return previousValue;
    }
  } else {
    return previousValue;
  }
}
